/**
 * Single source of truth for the primary title shown on a transaction row.
 *
 * Fallback order: first line of trimmed `note` → subcategory name →
 * category name → '—'.
 *
 * Only the FIRST line of the note is used as the title: OCR receipts store a
 * multi-line note (merchant on line 1, then an item list), and the list title
 * is a single nowrap+ellipsis line — using the whole note would spill the
 * item list into the title. The full note remains visible in TxDetail.
 *
 * Renaming a subcategory automatically flows to previously-saved rows
 * with empty note because the lookup is render-time, not write-time.
 */
import type { CategoryRow, TransactionRow } from './sheets/types';

export function displayTxName(
  tx: TransactionRow,
  category: CategoryRow | undefined,
  subcategory: CategoryRow | undefined,
): string {
  const trimmed = tx.note.trim();
  if (trimmed.length > 0) return trimmed.split('\n')[0]!.trim();
  if (subcategory && subcategory.name.length > 0) return subcategory.name;
  if (category && category.name.length > 0) return category.name;
  return '—';
}
